import React, { useState } from "react";
import { toggleRequestRestart, useGameDispatch } from "context/GameContext";
// Css
import classes from "./RestartGame.module.scss";

const RestartGame: React.FC = () => {
  const [active, setActive] = useState<boolean>(false);
  const gameDispatch = useGameDispatch();

  return (
    <div
      className={`${classes.container} ${active && classes.container_active}`}
    >
      <div className={classes.left_side} onClick={() => setActive(!active)}>
        <p className={classes.description}>Leave The Game</p>
      </div>
      <div className={classes.right_side}>
        <img
          onClick={() => toggleRequestRestart(gameDispatch)}
          className={classes.restart}
          src="assets/img/board/restart.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default RestartGame;
